import { Field, Form, ErrorMessage } from 'vee-validate'

export default {
  components: {
    Field,
    Form,
    ErrorMessage
  },
  methods: {
    isRequired(value) {
      if (value && value.trim()) {
        return true
      }
      return 'This field is required.'
    },
    fileRequired(value) {
      if (value && value.length) {
        if (value[0].size/(1024*1024) <= 6) {
          if (['application/pdf', 'application/word', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/png', 'image/jpeg'].includes(value[0].type)) {
            return true
          } else {
            return 'File format is not correct.'
          }
        } else {
          return 'File must be under 6MB.'
        }
      }
      return 'This field is required.'
    },
    validateEmail(value) {
      if (!value) {
        return 'This field is required';
      }
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
        return 'This field must be a valid email'
      }
      return true
    },
  }
}
